export default "__VITE_ASSET__zyMvKe$c__"